import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UserActions } from './user.action';
import { GetUserDataSuccessPayload } from './user.interface';
import { UserService } from './user.service';

@Injectable()
export class UserEffects {
  private readonly userService = inject(UserService);
  private readonly actions$ = inject(Actions);

  getUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.getUser),
      switchMap(() => {
        return this.userService.getUser().pipe(
          map((user: GetUserDataSuccessPayload) => UserActions.getUserSuccess({ user })),
          catchError(({ error }) => of(UserActions.getUserFailure(error))),
        );
      }),
    ),
  );
}
